import { Component, Input, Inject } from "@angular/core";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";
import { Rule } from "../../../../common/models/flow.dto";
import { genId } from "../../../../core/services/genId";

@Component({
    selector: "side-effect-start-another-workflow",
    templateUrl: "./side-effect-start-another-workflow.component.html",
    styleUrls: ['./side-effect-start-another-workflow.component.scss'],
    standalone: false
})
export class SideEffectStartAnotherWorkFlowComponent {
    _seConfiguration: any;

    set seConfiguration(value: any) {
        this._seConfiguration = value || {};
        this._seConfiguration.organizationId = this._seConfiguration.organizationId || '';
        this._seConfiguration.templateId = this._seConfiguration.templateId || '';
        this._seConfiguration.currentTemplateIdPath = this._seConfiguration.currentTemplateIdPath || '';
        this._seConfiguration.newTemplateIdPath = this._seConfiguration.newTemplateIdPath || '';
        this._seConfiguration.contextTransforms = this._seConfiguration.contextTransforms || [];
        this._seConfiguration.startAtSummary = this._seConfiguration.startAtSummary || false;
        this._seConfiguration.startMultipleWorkflows = (this._seConfiguration.startMultipleWorkflows != null) ? this._seConfiguration.startMultipleWorkflows : false;
        this._seConfiguration.numberOfWorkflowsRule = (this._seConfiguration.numberOfWorkflowsRule != null) ? this._seConfiguration.numberOfWorkflowsRule : null;
    }

    get contextTransforms(): { contextTarget: string, rule: Rule }[] {
        return this._seConfiguration.contextTransforms;
    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.seConfiguration = data.configuration;
    }

    addContextTransform() {
        this.contextTransforms.push({ contextTarget: null, rule: { ruleId: genId() } as Rule });
    }

    removeContextTransform(rule: Rule) {
        this.contextTransforms.splice(this.contextTransforms.findIndex(x => x.rule.ruleId === rule.ruleId), 1);
    }

    isStartAtSummaryChanged(is: boolean): void {
        this._seConfiguration.startAtSummary = is;
    }

    multipleFlowsRuleUpdated(rule: Rule): void {
        if (rule != null) {
            this.seConfiguration.numberOfWorkflowsRule = rule.expression;
        }        
    }
}

